import { GaEventService } from '@analytics/services/ga.event.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  OnChanges,
} from '@angular/core';
import { Comparison } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-overlay-large',
  templateUrl: './overlay-large.component.html',
  styleUrls: ['./overlay-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayLargeComponent implements OnChanges {
  constructor(
    private readonly viewOfferService: ViewOffersService,
    private readonly gaEventService: GaEventService
  ) {}
  /**
   * Emits an object of type event back to the parent component when the overlay close is clicked
   */
  @Output() closed: EventEmitter<Event> = new EventEmitter();

  /**
   * Emits an object of type event back to the parent component when the card cta is selected
   */
  @Output() selected: EventEmitter<Event> = new EventEmitter();

  /**
   * Emits an object of type event back to the parent component when the card close is clicked
   */
  @Output() removed: EventEmitter<Event> = new EventEmitter();

  /**
   * Receives array of comparisons to compare
   */
  @Input() comparisons = [] as Comparison[];

  /**
   * Show notice that spec table has differences
   */
  hasSpecDifferences = false;

  /**
   * Show and hide table spec differences
   */
  toggleSpecDifferences = false;

  /**
   * Fires when overlay close is clicked - passes in event object
   */
  onClose(e: Event) {
    this.closed.emit(e);
  }

  ngOnChanges() {
    if (this.comparisons) {
      this.hasSpecDifferences =
        this.viewOfferService.isAnySpecsDifferentToCurrent(this.comparisons);
    }
  }

  /**
   * Fires when card component cta is selected - passes in event object
   */
  onSelected(e: Event) {
    this.selected.emit(e);
    this.onClose(e);
  }

  /**
   * Fires when card component close is clicked to remove card - passes in event object
   */
  onRemove(e: Event) {
    this.toggleSpecDifferences = false;
    this.removed.emit(e);
  }

  /**
   * Fires when show only differences toggle is checked
   */
  toggleSpecDifferencesChecked() {
    this.toggleSpecDifferences = !this.toggleSpecDifferences;
    if (this.toggleSpecDifferences) {
      this.gaEventService.OfferSpecDifferencesClick();
    }
  }
}
